/**
 * Die Zusammenfassung der Anträge des Projekts im Fokus – für die aufgeklappte Zeile. Ohne
 * Projekt oder ohne Recht an den Anträgen nichts.
 */
import { useCallback, useEffect, useState } from "react";
import { permitsApi } from "../../../../services/api/permits";
import { PermitSummary } from "../../../../types";

export interface PermitSummaryState {
  summary: PermitSummary | null;
  failed: boolean;
}

export interface PermitSummaryResult extends PermitSummaryState {
  /** Neu laden, etwa nach einer Änderung in der Zeile – der bisherige Stand bleibt so lange stehen */
  reload: () => void;
}

export const usePermitSummary = (
  projectId: string | null,
  enabled: boolean,
): PermitSummaryResult => {
  const [state, setState] = useState<PermitSummaryState>({
    summary: null,
    failed: false,
  });
  const [version, setVersion] = useState(0);

  // Wechselt das Projekt, beginnt die Zeile leer; beim Nachladen bleibt der bisherige Stand.
  useEffect(() => {
    setState({ summary: null, failed: false });
  }, [projectId, enabled]);

  useEffect(() => {
    if (!projectId || !enabled) return;
    let current = true;
    permitsApi
      .getPermitSummary(projectId)
      .then((summary) => current && setState({ summary, failed: false }))
      .catch(() => current && setState({ summary: null, failed: true }));
    return () => {
      current = false;
    };
  }, [projectId, enabled, version]);

  const reload = useCallback(() => setVersion((v) => v + 1), []);
  return { ...state, reload };
};
